<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
    <template #DETAILS="{ visible, params }">
      <Details v-if="visible" :row="params"></Details>
    </template>
    <template #Email="{ visible, params }">
      <EmailDetails v-if="visible" :row="params"></EmailDetails>
    </template>
  </cTable>
</template>

<script>
import {
  getBill,
  add,
  getDetails,
  del,
  getBillClient,
  resetAmount,
  postAudit,
  postConfirm,
  getConfig,
  updateBill,
  ConversionUsd,
  getUsdRate,
  getMonthUsers,
  createMonthUserBill,
  exportMonthBill,
  exportAllBill,
  getOperator,
  cancelClientOff,
  previewEmail,
  appendCnbNo,
  xbDoHedge,
  changeBillHeader,
} from "@/api/finance/bill";
import { waitOffBill } from "@/api/finance/codList";
import { getAllClient, getCompanies } from "@/api/user/client";
import { getContract } from "@/api/user/CustomerContract";

import numFun from "@/utils/numFun";

import cTable from "@/base/common/index";
import Details from "./details";
import EmailDetails from "./email_details";
import toPage from "@/base/common/topage";
export default {
  name: "bill",

  components: {
    cTable,
    Details,
    EmailDetails,
  },
  mixins: [toPage],
  data() {
    let options = [
      { label: this.$t("month_t"), value: "MONTH" },
      { label: this.$t("half_moon"), value: "HALFMONTH" },
      { label: this.$t("week"), value: "WEEK" },
      { label: this.$t("day"), value: "DAY" },
    ];
    return {
      config: {
        isGetList: false,
      },
      methods: {
        list: (p) => {
          return getBill(p);
        },
        getCompanies,
        add,
        getDetails,
        del,
        getBillClient,
        resetAmount,
        postAudit,
        postConfirm,
        getConfig,
        updateBill,
        getAllClient,
        beforeHandleList: ({ data }) => {
          this.totalAmount = [];
          this.totalAmount.push({
            text: this.$t("total"),
            replace_currency: "",
            total_amount: data.totalAmount,
          });
        },
        ConversionUsd,
        createMonthUserBill,
        getUsdRate,
        getMonthUsers,
        exportMonthBill,
        exportAllBill,
        getOperator,
        cancelClientOff,
        appendCnbNo,
        waitOffBill,
        xbDoHedge,
        changeBillHeader,
        getContract,
      },
      totalAmount: [],
      modals: {
        append: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page
                .handleRequestMethods("appendCnbNo", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "Please Enter airway_number",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ airway_number: 24 }],
          fields: [
            {
              name: this.$t("order_number"),
              key: "airway_number",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("order_number"),
              bind: {
                type: "textarea",
                rows: 10,
              },
            },
          ],
        },
        add: {
          methods: {
            ok({ row, close }) {
              let data = {
                show_sku: row.show_sku,
              };
              let requestType = "";
              if (row.period == "MONTH") {
                data.client_id = this.selectAll.map((item) => item.client_id);
                requestType = "createMonthUserBill";
                if (data.client_id.length > 1) {
                  this.$Message["error"]({
                    background: true,
                    content: this.$t("rule_sel_tips"),
                    duration: 5,
                  });
                  return;
                }
              } else {
                data.cache_token = this.selectAll.map(
                  (item) => item.airway_token
                );
                requestType = "add";
              }
              this.$page
                .handleRequestMethods(requestType, data, false, true)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              period: [
                {
                  required: true,
                  message: "Please select period",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [{ period: 24 }, { show_sku: 24 }, { client: 24 }],
          fields: [
            {
              name: () => this.$t("period"),
              key: "period",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("period"),
              options: options,
              methods: {
                async "on-change"({ formData }) {
                  this.$page.getModal("add").list = [];
                  if (formData.period) {
                    let data = (
                      await this.$page.handleRequestMethods(
                        "getBillClient",
                        this.formData,
                        true,
                        true
                      )
                    ).payload;
                    this.$page.getModal("add").client = this.$page.getModal(
                      "add"
                    ).list = data;
                  }
                },
              },
            },
            {
              name: () => this.$t("whether") + this.$t("show1") + "SKU",
              key: "show_sku",
              component: "Radio",
              placeholder: () =>
                this.$t("select") +
                this.$t("whether") +
                this.$t("show1") +
                "SKU",
              options: [
                {
                  label: this.$t("YES"),
                  value: 1,
                },
                {
                  label: this.$t("NO"),
                  value: 0,
                },
              ],
              bind: {
                border: true,
              },
              default: 0,
            },
            {
              name: () => this.$t("clientName"),
              key: "client",
              component: "Input",
              placeholder: () =>
                this.$t("enter") + this.$t("clientName") + this.$t("search"),
              methods: {
                "on-search"({ formData }) {
                  let that = this.$page.getModal("add");
                  let arr = that.client;
                  that.list = arr.filter(
                    (item) =>
                      item.shipper_account
                        .toLowerCase()
                        .indexOf(formData.client.toLowerCase()) !== -1
                  );
                },
              },
              bind: {
                suffix: "ios-search",
                search: true,
              },
            },
          ],
          table: {
            config: {
              height: 300,
            },
            fields: [
              {
                type: "checkbox",

                width: 60,
                fixed: "left",
              },
              {
                name: () => this.$t("clientName"),
                align: "left",
                key: "shipper_account",
                minWidth: 100,
              },
              {
                name: () => this.$t("period"),
                key: "billing_cycle",

                minWidth: 100,
                methods: {
                  render() {
                    return options.find(
                      (item) =>
                        item.value ==
                        this.getModal("add").$refs["form"].formData.period
                    ).label;
                  },
                },
              },
              {
                name: () => this.$t("salesman"),
                key: "salesman_account",
                align: "left",
                minWidth: 100,
              },
            ],
          },
        },
        update: {
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods("updateBill", row).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur",
                },
              ],
              total_real_amount: [
                {
                  required: true,
                  message: "Please Enter total_real_amount",
                  trigger: "blur",
                },
              ],
              total_fee: [
                {
                  required: true,
                  message: "Please Enter total_fee",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ name: 24 }, { rate: 24 }],
          fields: [
            {
              name: () => this.$t("rate"),
              key: "rate",
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("rate"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
              default: 0,
            },

            {
              name: () => this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },

            // {
            //   name: this.$t("Remarks"),
            //   key: "remarks",
            //   component: "Input",
            //   placeholder: () => this.$t("enter") + this.$t("Remarks")
            // },
            // {
            //   name: this.$t("type"),
            //   key: "types",
            //   component: "Radio",
            //   options: [
            //     { label: "总部", value: 1 },
            //     { label: "分公司", value: 2 },
            //     { label: "部门", value: 3 },
            //     { label: "岗位", value: 4 }
            //   ],
            //   bind: {
            //     border: true
            //   }
            // }
          ],
        },
        writeOff: {
          methods: {
            ok({ row, close }) {
              // let data = this.$refs["form"].handleFilterData({
              //   ids: this.$page.selectAll.map(item => item.id)
              // });
              // console.log(data);
              // console.log(row);
              // return;
              this.$page.handleRequestMethods("postAudit", row).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              status: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              o_type: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
              remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ status: 24 }, { o_type: 24 }, { remarks: 24 }],
          fields: [
            {
              name: () => this.$t("exlType"),
              key: "status",
              component: "Radio",
              options: [
                { label: this.$t("refuse"), value: 0 },
                { label: this.$t("allow"), value: 1 },
              ],
              bind: {
                border: true,
              },
            },
            {
              name: () => this.$t("type"),
              key: "o_type",
              component: "Radio",
              options: [
                { label: this.$t("onLine"), value: 1 },
                { label: this.$t("offLine"), value: 2 },
              ],
              bind: {
                border: true,
              },
              default: 1,
              show({ row }) {
                return row.status == 1;
              },
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 5,
              },
              show({ row }) {
                return row.o_type == 2;
              },
            },
          ],
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 1500,
            },
            modalContentBind: {
              style: {
                height: "700px",
              },
            },
          },
          footer: { show: () => false },
        },
        calculate: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("ConversionUsd", row, true)
                .then(() => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur",
                },
              ],
              rate: [
                {
                  required: true,
                  type: "number",
                  message: "Please Enter rate",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ name: 24 }, { rate: 24 }],
          fields: [
            {
              name: () => this.$t("rate"),
              key: "rate",
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("rate"),
              bind: {
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
              default: 0,
            },

            {
              name: () => this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
          ],
        },
        preview: {
          contentSlot: "Email",
          config: {
            modalBind: {
              // draggable: true,
              // transfer: true,
              width: 920,
            },
          },
          footer: { show: () => false },
        },
        hedge: {
          methods: {
            ok({ row, close }) {
              let data = {
                hedge_bill_list: this.selectAll,
                bill_amount: row.final_amount_cny,
                bill_id: row.id,
                token: row.token,
                hedge_bill_amount: row.hedge_bill_amount,
              };
              this.$page.handleRequestMethods("xbDoHedge", data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
            checkTable({ row }) {
              let amount = 0;
              row.map((item) => {
                amount += parseFloat(item.amount);
                return;
              });
              this.$refs["form"].formData.hedge_bill_amount = parseFloat(
                amount.toFixed(2)
              );
              this.$forceUpdate();
            },
          },
          config: {
            modalBind: {
              width: 800,
              draggable: true,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            formBind: {},
          },
          grid: [
            {
              name: this.$t("basic_information"),
              children: [
                {
                  client_name: 8,
                  final_amount_cny: 8,
                  hedge_bill_amount: 8,
                },
              ],
            },
          ],
          fields: [
            {
              name: () => this.$t("clientName") + ":",
              key: "client_name",
            },
            {
              name: () =>
                this.$t("NotWrittenOff") + this.$t("reChAmount") + "(CNY):",
              key: "final_amount_cny",
              bind: {
                style: {
                  color: "red",
                  fontSize: "20px",
                  fontWeight: "bold",
                },
              },
            },
            {
              name: () => this.$t("selected") + this.$t("reChAmount") + ":",
              key: "hedge_bill_amount",
              bind: {
                style: {
                  color: "red",
                  fontSize: "20px",
                  fontWeight: "bold",
                },
              },
            },
          ],
          table: {
            config: {
              height: 500,
            },
            fields: [
              {
                type: "checkbox",
                width: 60,
                fixed: "left",
              },
              {
                name: () => this.$t("bill_name"),
                align: "left",
                key: "name",
              },
              {
                name: () => this.$t("bill_number"),
                key: "bill_number",
                align: "left",
              },
              {
                name: () => this.$t("codTypes"),
                key: "b_type",
              },
              {
                name: () => this.$t("currencyCode"),
                key: "currency",
                width: 80,
              },
              {
                name: () => this.$t("amount"),
                key: "amount",
              },
            ],
          },
        },
        updateContract: {
          methods: {
            ok({ row, close }) {
              let data = {
                ids: this.$page.selectAll.map((item) => item.id),
                header_id: row.header_id,
              };
              this.$page
                .handleRequestMethods("changeBillHeader", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            formBind: {
              labelWidth: 100,
            },
            rules: {
              header_id: [
                {
                  required: true,
                  message: "connot be empty",
                  type: "number",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            {
              header_id: 22,
            },
          ],
          fields: [
            {
              name: this.$t("contractHeader"),
              key: "header_id",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("contractHeader"),
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getContract")
                  ).payload;
                  this.$forceUpdate();
                },
              },
            },
          ],
        },
      },
      footer: {
        show: () => true,
        render: (h) => {
          return h(
            "div",
            {
              class: "footer-content",
            },
            this.totalAmount.map((item) => {
              return h(
                "div",
                {
                  class: "footer-content-item",
                },
                [
                  h("span", { class: "span-head" }, item.text),
                  h(
                    "span",
                    { class: "span-head" },
                    item.replace_currency + ":"
                  ),
                  h(
                    "span",
                    {
                      class: "span-title",
                    },
                    numFun.formatNum(parseFloat(item.total_amount))
                  ),
                ]
              );
            })
          );
        },
      },
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          // {
          //   key: "time_type",
          //   placeholder() {
          //     return this.$t("select") + this.$t("date") + this.$t("type");
          //   },
          //   component: "Select",
          //   options: []
          // },
          {
            key: "status",
            placeholder() {
              return this.$t("select") + this.$t("exlType");
            },
            component: "Select",
            options: [],
          },
          {
            key: "clientId",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id",
            },
          },
          {
            key: "ownership",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id",
            },
          },
          {
            key: "operator_id",
            placeholder() {
              return this.$t("select") + this.$t("status_operator");
            },
            component: "Select",
            options: [],
            // config: {
            //   label: "account",
            //   value: "id"
            // }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              bind: {
                icon: "md-add",
                type: "warning",
              },
              id: 127,
            },
            {
              name: () => this.$t("update") + this.$t("contractHeader"),
              type: "updateContractTitle",
              fnName: "updateContractTitle",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-checkmark",
                type: "error",
              },
            },
            {
              name: this.$t("export"),
              // type: "export",
              // fnName: "export",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              btnBind: {
                // icon: "md-arrow-down",
                type: "primary",
              },
              list: [
                {
                  name: this.$t("ListData"),
                  type: "export",
                  fnName: "export",
                  disabled() {
                    return !this.selectAll.length;
                  },
                  // bind: {
                  //   icon: "md-arrow-down",
                  //   type: "primary"
                  // }
                },
                {
                  name: this.$t("month_t") + this.$t("bill1"),
                  type: "monthBill",
                  fnName: "monthBill",
                  disabled() {
                    return !this.selectAll.length;
                  },
                  id: 485,
                  // id: 305
                  // bind: {
                  //   icon: "md-arrow-down",
                  //   type: "primary"
                  // }
                },
                {
                  name: this.$t("summary") + this.$t("export"),
                  type: "allBill",
                  fnName: "allBill",
                  disabled() {
                    return !this.selectAll.length;
                  },
                  id: 529,
                  // bind: {
                  //   icon: "md-arrow-down",
                  //   type: "primary"
                  // }
                },
              ],
            },
          ],
          methods: {
            updateContractTitle() {
              this.getModal("updateContract").open({}, function () {
                this.setTitle(this.$t("update") + this.$t("contractHeader"));
              });
            },
            export() {
              this.exportExc();
            },
            allBill() {
              let data = {
                bill_id: this.selectAll.map((item) => item.id),
              };
              this.openLoading();
              this.handleRequestMethods("exportAllBill", data).then((res) => {
                window.open(this.$globalUrl + res.payload);
                this.closeLoading();
              });
            },
            monthBill() {
              let data = {
                id: this.selectAll.map((item) => item.id),
              };
              this.openLoading();
              this.handleRequestMethods("exportMonthBill", data).then((res) => {
                window.open(this.$globalUrl + res.payload);
                this.closeLoading();
              });
            },
            add() {
              this.getModal("add").setTitle(this.$t("add"));
              this.getModal("add").type = "add";
              this.getModal("add").open();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          align: "center",
          // component: this.$hasPermission(664) ? "Button" : "span",
          component: "Button",
          minWidth: 180,
          copy: true,
          fixed: "left",
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            render({ row }) {
              return row.bill_number;
            },
            click({ row }) {
              // if (this.$hasPermission(664))
              this.$page.getModal("showDetails").open(row, function () {
                this.setTitle(row.bill_number);
              });
            },
          },
        },
        {
          name: () => this.$t("clientName"),
          align: "center",
          key: "client_account",
          fixed: "left",
          width: 100,
          methods: {
            render({ row }) {
              return row.financeInfo.client_account;
            },
          },
        },
        // {
        //   name: () => this.$t("CollectionUser"),
        //   align: "center",
        //   key: "target_type_txt",
        //   minWidth: 100,
        //   bind: {
        //     style({ row }) {
        //       if (row.target_type === 2) {
        //         return { color: "red" };
        //       }
        //     }
        //   }
        // },
        {
          name: () => this.$t("codNAme"),
          align: "center",
          key: "name",
          minWidth: 100,
          methods: {
            render({ row }) {
              return row.financeInfo.name;
            },
          },
        },
        {
          name: () => this.$t("orderNums"),
          key: "total_votes",
          align: "center",
          minWidth: 80,
          methods: {
            render({ row }) {
              return row.financeInfo.total_votes;
            },
          },
        },
        // {
        //   name: () => this.$t("total_votes"),
        //   align: "center",
        //   key: "total_votes",
        //   width: 80
        // },
        // {
        //   name: () => this.$t("amount") + "(CNY)",
        //   key: "total_cny",
        //   align: "center",
        //   width: 120
        // },
        // {
        //   name: () => this.$t("amount") + "(USD)",
        //   align: "center",
        //   key: "total_usd",
        //   width: 120
        // },
        // {
        //   name: () => this.$t("rate") + "(USD-CNY)",
        //   align: "center",
        //   key: "usd_to_cny_rate",
        //   width: 130
        // },
        {
          name: () => this.$t("OriginalCurrency"),
          children: [
            {
              name: this.$t("currency_t"),
              align: "center",
              key: "financeInfo.bill_currency",
              width: 80,
            },
            {
              name: this.$t("total_amount"),
              align: "center",
              key: "financeInfo.bill_amount",
              width: 80,
            },
          ],
        },
        {
          name: () => this.$t("to"),
          children: [
            {
              name: this.$t("toCurrency"),
              align: "center",
              key: "financeInfo.to_bill_currency",
              width: 80,
            },
            {
              name: this.$t("rate"),
              align: "center",
              key: "financeInfo.to_bill_rate",
              width: 80,
            },
            {
              name: this.$t("total_amount"),
              align: "center",
              key: "financeInfo.to_bill_amount",
              width: 80,
            },
          ],
        },
        // {
        //   name: () => this.$t("clientName"),
        //   align: "center",
        //   key: "clientInfo",
        //   width: 100,
        //   methods: {
        //     render({ value }) {
        //       return value && value.account;
        //     },
        //   },
        // },

        {
          name: () => this.$t("status_operator"),
          align: "center",
          key: "operator_name",
          width: 100,
          // methods: {
          //   render({ value }) {
          //     return value && value.account;
          //   }
          // }
          methods: {
            render({ row }) {
              return row.financeInfo.operator_name;
            },
          },
        },
        {
          name: () => this.$t("audit"),
          align: "center",
          key: "audit_account",
          width: 100,
          methods: {
            render({ row }) {
              return row.financeInfo.audit_account;
            },
          },
        },
        {
          name: () => this.$t("createTime"),
          align: "center",
          key: "create_time",
          width: 170,
        },
        {
          name: () => this.$t("confirm_time"),
          key: "confirm_time",
          align: "center",
          minWidth: 170,
          methods: {
            render({ row }) {
              return row.financeInfo.confirm_time;
            },
          },
        },
        {
          name: () => this.$t("audit_time"),
          key: "audit_time",
          align: "center",
          minWidth: 170,
          methods: {
            render({ row }) {
              return row.financeInfo.audit_time;
            },
          },
        },
        {
          name: () => this.$t("paid_time"),
          key: "paid_time",
          align: "center",
          minWidth: 170,
          methods: {
            render({ row }) {
              return row.financeInfo.paid_time;
            },
          },
        },
        {
          name: () => this.$t("exlType"),
          key: "status_txt",
          align: "center",
          minWidth: 100,
          methods: {
            render({ row }) {
              return row.financeInfo.status_txt;
            },
          },
        },
        // {
        //   name: () => this.$t("b2bClient") + this.$t("order_desc"),
        //   key: "client_remarks",
        //
        //   minWidth: 170
        // },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 550,
          fixed: "right",
          list: [
            {
              name: () => this.$t("addTo"),
              type: "append",
              fnName: "append",
              bind: {
                type: "warning",
              },
              disabled({ row }) {
                return row.financeInfo.status != "WAIT_CONFIRM";
              },
              id: 897,
            },
            {
              name: () => this.$t("resAmount"),
              width: 100,
              fnName: "recalculate",
              bind: {
                type: "error",
                size: "small",
              },
              disabled({ row }) {
                return row.financeInfo.status != "WAIT_CONFIRM";
              },
              if: 134,
              methods: {
                render() {
                  return this.$t("resAmount");
                },
              },
            },
            // {
            //   name: () => this.$t("to_usd") + this.$t("Conversion"),
            //   type: "Conversion",
            //   fnName: "ConversionFun",
            //   bind: {
            //     type: "warning"
            //   },
            //   disabled({ row }) {
            //     return (
            //       row.financeInfo.amount_usd !== "0.00" || row.financeInfo.status != "WAIT_CONFIRM"
            //     );
            //   },
            //   id: 460
            // },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              disabled({ row }) {
                return row.financeInfo.status != "WAIT_CONFIRM";
              },
              id: 353,
            },
            {
              name: () => this.$t("confirmOrder"),
              type: "confirmOrder",
              fnName: "confirmOrder",
              bind: {
                type: "error",
              },
              disabled({ row }) {
                return row.financeInfo.status != "WAIT_CONFIRM";
              },
              id: 129,
            },
            // {
            //   name: () => this.$t("hedging"),
            //   type: "hedge",
            //   fnName: "hedge",
            //   bind: {
            //     type: "error"
            //   },
            //   disabled({ row }) {
            //     return row.financeInfo.status != "CONFIRMED";
            //   }
            // },
            {
              name: () => this.$t("writeOff"),
              type: "writeOff",
              fnName: "writeOff",
              bind: {
                type: "warning",
              },
              disabled({ row }) {
                return row.financeInfo.status != "CONFIRMED";
              },
              id: 130,
            },
            {
              name: () => this.$t("email") + this.$t("preview"),
              type: "preview",
              fnName: "preview",
              bind: {
                type: "success",
              },
              disabled({ row }) {
                return row.financeInfo.status != "CONFIRMED";
              },
              id: 882,
            },
            // {
            //   name: () => this.$t("cancel") + this.$t("writeOff"),
            //   type: "noWriteOff",
            //   fnName: "noWriteOff",
            //   bind: {
            //     type: "info"
            //   },
            //   disabled({ row }) {
            //     return row.financeInfo.status != "PAID";
            //   },
            //   id: 881
            // },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              disabled({ row }) {
                return row.financeInfo.status != "WAIT_CONFIRM";
              },
              id: 131,
            },
          ],
          methods: {
            hedge({ row }) {
              let data = {
                type: "XB",
                bill_id: row.id,
              };
              this.handleRequestMethods("waitOffBill", data).then((res) => {
                let data = res.payload.data;
                row.token = res.payload.token;
                row.hedge_bill_amount = 0;
                row.client_name = row.clientInfo && row.clientInfo.account;
                row.final_amount_cny = row.amount;
                this.getModal("hedge").open(row, function () {
                  this.setTitle(
                    row.bill_number + "(" + this.$t("hedging") + ")"
                  );
                  this.list = data;
                });
              });
            },
            append({ row }) {
              this.getModal("append").open({ id: row.id }, function () {
                this.setTitle(this.$t("addTo"));
              });
            },
            recalculate({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("resAmount"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("resetAmount", row.id).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
            ConversionFun({ row }) {
              this.handleRequestMethods("getUsdRate").then((res) => {
                this.getModal("calculate").open(
                  {
                    name: row.name,
                    rate: res.payload,
                    id: row.id,
                  },
                  function () {
                    this.setTitle(
                      row.bill_number +
                        "(" +
                        this.$t("to_usd") +
                        this.$t("Conversion") +
                        ")"
                    );
                  }
                );
              });
            },
            // add({ row }) {
            //   this.getModal("add").open({ id: row.id }, function () {
            //     this.setTitle(row.bill_number + "(" + this.$t("addTo") + ")");
            //   });
            // },
            update({ row }) {
              this.getModal("update").open(
                {
                  name: row.name,
                  rate: row.usd_to_cny_rate,
                  id: row.id,
                },
                function () {
                  this.setTitle(
                    row.bill_number + "(" + this.$t("update") + ")"
                  );
                }
              );
            },
            preview({ row }) {
              previewEmail({ bill_id: row.id }).then((res) => {
                if (res.data.status) {
                  this.getModal("preview").open(res.data.payload, function () {
                    this.setTitle(
                      row.bill_number +
                        "(" +
                        this.$t("email") +
                        this.$t("preview") +
                        ")"
                    );
                  });
                }
              });
              // console.log(row);
            },
            confirmOrder({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("confirmOrder"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("postConfirm", row.id).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
            writeOff({ row }) {
              this.getModal("writeOff").open({ id: row.id }, function () {
                this.setTitle(
                  row.bill_number + "(" + this.$t("writeOff") + ")"
                );
              });
            },
            noWriteOff({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") + this.$t("cancel") + this.$t("writeOff"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("cancelClientOff", row.id).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("whether") + this.$t("delete"),
                width: 300,
                content: this.$t("bill1") + "(" + row.bill_number + ")",
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
  async mounted() {
    let data = (await getConfig()).data.payload;
    let client = (await getAllClient()).data.payload.rows;
    let operator = (await getOperator()).data.payload;
    let companiesList = (await getCompanies()).data.payload;
    this.header.searchs.forEach((item) => {
      if (item.key === "status")
        item.options = Object.keys(data.status).map((item) => ({
          value: item,
          label: data.status[item],
        }));
      if (item.key === "clientId") item.options = client;
      if (item.key === "operator_id") item.options = operator;
      if (item.key === "ownership") item.options = companiesList;
    });
  },
};
</script>
